import { useEffect, useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';
import { OfficeAddress } from '../models/visitsInvestorModel';
import { getOfficeAddressEndpoint } from '../services/visitsInvestorService';

const useOfficeAddress = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const [officeAddress, setOfficeAddress] = useState<OfficeAddress | null>(
    null,
  );

  useEffect(() => {
    callEndpoint(getOfficeAddressEndpoint(token))
      .then(({ status, data }) => {
        if (status === 200) setOfficeAddress(fetchResponseAdapter(data).data);
      })
      .catch(() => setOfficeAddress(null));
  }, []);

  return { officeAddress };
};

export default useOfficeAddress;
